import React from 'react';
import DecimalInput from './ui/DecimalInput';
import { FeedStockNutritionalInfo } from '../api/feedStock';

interface NutritionalInfoDecimalInputProps {
  label: string;
  field: keyof FeedStockNutritionalInfo;
  unit: string;
  value: number | undefined;
  onChange: (field: keyof FeedStockNutritionalInfo, value: number | undefined) => void;
  min?: number;
  max?: number;
  placeholder?: string;
  className?: string;
  error?: string;
}

export default function NutritionalInfoDecimalInput({
  label,
  field,
  unit,
  value,
  onChange,
  min = 0,
  max,
  placeholder = '0.0',
  className = '',
  error,
}: NutritionalInfoDecimalInputProps) {
  return (
    <div className={className}>
      <label className="mb-1 block text-sm font-medium text-slate-700">
        {label} {unit && <span className="font-normal text-slate-500">({unit})</span>}
      </label>
      <DecimalInput
        value={value}
        onChange={(next) => onChange(field, next)}
        allowEmpty
        min={min}
        max={max}
        placeholder={placeholder}
        error={error}
        inputClassName={`block w-full input border-gray-300 shadow-sm sm:text-sm ${error ? 'border-red-300' : ''}`}
      />
    </div>
  );
}
